import { KeyValue } from '@/main/models/common';
import {
  AssessmentTypeTypes,
  AssessmentTypeActionTypes
} from './assessmentTypeTypes';

export function getAssessmentType(): AssessmentTypeActionTypes {
  return {
    type: AssessmentTypeTypes.GET_ASSESSMENT_TYPE
  };
}

export function saveAssessmentType(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): AssessmentTypeActionTypes {
  return {
    type: AssessmentTypeTypes.SAVE_ASSESSMENT_TYPE,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerAssessmentType(): AssessmentTypeActionTypes {
  return {
    type: AssessmentTypeTypes.RESET_REDUCER_ASSESSMENT_TYPE
  };
}

